import type { InterviewPersonaLike, SessionsInterviewDeps } from './SessionsLayout.types';

export function InterviewDownloadWrapper({
  interview,
  persona,
}: {
  interview: SessionsInterviewDeps;
  persona: InterviewPersonaLike | null;
}) {
  const { download, isDownloading } = interview.useDownload(persona);
  const handleDownload = (type: 'conversation' | 'persona') => {
    void download(type);
  };
  return <interview.DownloadDropdown onDownload={handleDownload} isDownloading={isDownloading} />;
}
